import { Link } from "react-router-dom";
import { MovaraMark } from "@/components/Brand";
import { Ship, Truck, ArrowRight } from "lucide-react";

const OPTIONS = [
  {
    key: "caribbean",
    to: "/sample-board/caribbean",
    label: "Caribbean Maritime",
    icon: Ship,
    desc: "Inter-island shipping — cargo lands at the port by vessel, then runs final-mile to island resorts and merchants. Drop-off proof photos + WhatsApp tracking links.",
    tags: ["Vessel + Final-Mile", "St. Kitts & Antigua", "Drop-Off Proof"],
  },
  {
    key: "overland",
    to: "/sample-board/overland",
    label: "US Overland",
    icon: Truck,
    desc: "Continental trucking — pickup, line-haul transit, and dock-to-dock delivery across mainland lanes with manifests and proof of delivery.",
    tags: ["Carrier Pickup", "Cross-State Lanes", "Proof of Delivery"],
  },
];

export default function SampleBoardChooser() {
  return (
    <div className="min-h-screen bg-[#0B132B] text-white flex flex-col">
      <header className="px-4 sm:px-6 h-14 flex items-center gap-2 border-b border-white/10">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <MovaraMark className="h-5 w-6" />
          <span className="font-heading font-semibold text-[15px]">MovaRaBoard</span>
        </Link>
        <Link to="/request-access" data-testid="chooser-request-btn"
          className="ml-auto h-9 px-4 rounded-md bg-[#D97706] text-white text-[12.5px] font-black border-2 border-white/0 hover:bg-[#B45309] transition-colors flex items-center gap-1.5">
          Request a Walkthrough <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </header>

      <main className="flex-1 max-w-5xl w-full mx-auto px-4 sm:px-6 py-14 sm:py-20">
        <p className="text-[12px] font-black tracking-[0.2em] uppercase text-[#D97706] mb-3">Live Sample Boards</p>
        <h1 className="font-heading font-black text-3xl sm:text-4xl leading-tight mb-3">Pick a demo to explore</h1>
        <p className="text-white/60 text-sm max-w-xl mb-10">Two read-only sample workspaces, each pre-loaded with a full day of shipment data. No login required.</p>

        <div className="grid sm:grid-cols-2 gap-5">
          {OPTIONS.map(({ key, to, label, icon: Icon, desc, tags }) => (
            <Link key={key} to={to} data-testid={`chooser-${key}`}
              className="group bg-white text-[#0B132B] rounded-md border-2 border-[#0B132B] shadow-[4px_4px_0px_0px_rgba(217,119,6,1)] hover:shadow-[6px_6px_0px_0px_rgba(217,119,6,1)] hover:-translate-y-0.5 transition-all p-6 flex flex-col">
              <div className="flex items-center gap-3 mb-4">
                <span className="h-11 w-11 rounded-md bg-[#0B132B] flex items-center justify-center">
                  <Icon className="h-5 w-5 text-[#D97706]" strokeWidth={2} />
                </span>
                <h2 className="font-heading font-black text-xl">{label}</h2>
              </div>
              <p className="text-[13.5px] text-ink-2 leading-relaxed flex-1">{desc}</p>
              <div className="flex flex-wrap gap-1.5 mt-4">
                {tags.map((t) => (
                  <span key={t} className="text-[10.5px] font-bold uppercase tracking-wide px-2 py-1 rounded-sm border border-[#0B132B]/25 bg-[#F8FAFC]">{t}</span>
                ))}
              </div>
              <div className="mt-5 flex items-center gap-1.5 text-[13px] font-black text-[#D97706] group-hover:gap-2.5 transition-all">
                Open board <ArrowRight className="h-4 w-4" />
              </div>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}
